import React from 'react';
import * as CurrencyFormat from 'react-currency-format';
import { ZdsIcon, ZdsLink } from '@zig-design-system/ui-components-react';
import Translation from '../components/Translation';
export var Formats;
(function (Formats) {
    Formats[Formats["number"] = 0] = "number";
    Formats[Formats["currency"] = 1] = "currency";
    Formats[Formats["squareMeters"] = 2] = "squareMeters";
    Formats[Formats["postalCode"] = 3] = "postalCode";
    Formats[Formats["dateTime"] = 4] = "dateTime";
    Formats[Formats["link"] = 5] = "link";
    Formats[Formats["phone"] = 6] = "phone";
    Formats[Formats["email"] = 7] = "email";
    Formats[Formats["buyPrice"] = 8] = "buyPrice";
    Formats[Formats["batCode"] = 9] = "batCode";
})(Formats || (Formats = {}));
const FormatUtility = {
    format: (value, format) => {
        switch (format) {
            case Formats.currency:
                return (React.createElement(CurrencyFormat, { value: value, prefix: '€ ', thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: true, displayType: 'text' }));
            case Formats.buyPrice:
                return (React.createElement(CurrencyFormat, { value: value, prefix: '€ ', thousandSeparator: '.', decimalSeparator: ',', decimalScale: 0, fixedDecimalScale: true, displayType: 'text' }));
            case Formats.number:
                return (React.createElement(CurrencyFormat, { value: value, thousandSeparator: '.', decimalSeparator: ',', displayType: 'text' }));
            case Formats.squareMeters:
                return value + 'm²';
            case Formats.postalCode:
                return FormatUtility._postalCode(value);
            case Formats.dateTime:
                return new Date(value).toLocaleString(document.documentElement.lang, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                });
            case Formats.link:
                return (React.createElement(ZdsLink, { linkTarget: "_blank", link: FormatUtility._link(value) }, value));
            case Formats.phone:
                return React.createElement(ZdsLink, { link: 'tel:' + value }, value);
            case Formats.email:
                return React.createElement(ZdsLink, { link: 'mailto:' + value }, value);
            case Formats.batCode:
                return FormatUtility._batCode(value);
            default:
                return value;
        }
    },
    _postalCode: (value) => {
        //Dutch postal code check
        const regex = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
        if (regex.test(value) && value.length === 6) {
            return value.substring(0, 4) + ' ' + value.substring(4).toUpperCase();
        }
        return value;
    },
    _link: (value) => {
        if (value.startsWith('http://') || value.startsWith('https://')) {
            return value;
        }
        return 'https://' + value;
    },
    _batCode: (value) => {
        const iconMap = {
            GEL: 'horizontal-rule',
            ROA: 'walker',
            ROL: 'wheelchair-move',
            RUI: 'wheelchair',
        };
        return (React.createElement(React.Fragment, null,
            iconMap[value] && (React.createElement(React.Fragment, null,
                React.createElement(ZdsIcon, { name: iconMap[value], library: "fa-regular", slot: "icon", size: "md" }),
                ' ')),
            React.createElement(Translation, { item: `tx_zigrealestate_domain_model_rentableunit.bat_code.${value.toLowerCase()}` })));
    },
};
export default FormatUtility;
